import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("ReportsStore");
export const useReportsStoreActions = useActions;
export const useReportsStoreGetters = useGetters;
export const useReportsStoreMutations = useMutations;
export const useReportsStoreState = useState;